import { render } from "./JointCommitteeMembersEditor.vue?vue&type=template&id=5bb5ee49&scoped=true"
import script from "./JointCommitteeMembersEditor.vue?vue&type=script&lang=js"
export * from "./JointCommitteeMembersEditor.vue?vue&type=script&lang=js"

import "./JointCommitteeMembersEditor.vue?vue&type=style&index=0&id=5bb5ee49&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5bb5ee49"

export default script